import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ImportModel } from '@app/core/models/imports/import.model';
import { ImportService } from '@app/core/services/import.service';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { SessionStorageKeys } from '@app/core/models/configuration/sessionstorage-keys.model';
import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class ImportsResolver  {
  constructor(private importService: ImportService,
    private sessionStorageService: SessionStorageService) {
  }

  resolve(): Observable<ImportModel[]> {
    const dateFilters = this.sessionStorageService.get<any>(SessionStorageKeys.IMPORTS_LOG);
    let fromDate: string | null = null;
    let toDate: string | null = null;
    if (!_.isNil(dateFilters)) {
      if (!_.isNil(dateFilters.fromDate)) {
        fromDate = dateFilters.fromDate;
      }
      if (!_.isNil(dateFilters.toDate)) {
        toDate = dateFilters.toDate;
      }
    }

    return this.importService.getImports(fromDate, toDate);
  }
}
